export default "__VITE_ASSET__CqZbkck5__"